import api from './api.service';
import { Customer } from '../types/customer.types';

export const addCustomer = async (customerData: Omit<Customer, 'id' | 'createdAt' | 'updatedAt' | 'deletedAt'>): Promise<Customer> => {
  const response = await api.post('/customers', customerData);
  return response.data.data;
};

export const addPublicCustomer = async (customerData: Omit<Customer, 'id' | 'createdAt' | 'updatedAt' | 'deletedAt'>): Promise<Customer> => {
  const response = await api.post('/customers/public', customerData);
  return response.data.data;
};

export const updateCustomer = async (customerId: string, customerData: Partial<Customer>): Promise<Customer> => {
  const response = await api.put(`/customers/${customerId}`, customerData);
  return response.data.data;
};
